export const isUndefinedOrSpaces = (str: unknown): boolean =>{
  if( str === undefined || str === null){
    return true;
  }
  if (typeof str === 'string') {
    return str.trim().length === 0;
  }
  return false;
} 